import { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Toaster } from 'sonner';
import AppRoute from '@/components/layouts/AppRoute';
import { ProtectedRoute } from '@/components/layouts/ProtectedRoute';
import { PublicRoute } from '@/components/layouts/PublicRoute';
// import AuthLayout from '@/components/layouts/AuthLayout';
import PageLoader from '@/components/template/PageLoader';
import protectedRoutes from '@/configs/routes/protected-routes';
import { PATHS } from '@/constants/page-paths';
import publicRoutes from '@/configs/routes/public-routes';

const AllRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<ProtectedRoute />}>
        {protectedRoutes?.map((route) => (
          <Route
            key={route.name}
            path={route.path}
            Component={() => <AppRoute {...route} />}
          />
        ))}
      </Route>
      <Route path="/" element={<PublicRoute/>}>
        {publicRoutes?.map((route) => (
          <Route
            key={route.name}
            path={route.path}
            Component={() => <AppRoute {...route} />}
          />
        ))}
      </Route>
      <Route path="*" element={<Navigate to={PATHS.HOME} />} />
      
    </Routes>
  );
};

const Pages = () => {
  return (
    <>
      <Toaster position="bottom-center" />
      <Suspense fallback={<PageLoader />}>
        <AllRoutes />
      </Suspense>
    </>
  );
};

export default Pages;